// HARP Configs
import passwordAndAccountRecoveryConfig from './configs/harp/password-and-account-recovery';
import manualIdentityProofingConfig from './configs/harp/manual-identity-proofing';
import userResearchFeedbackConfig from './configs/harp/user-research-feedback';

// CMS Employee or Contractor Support Configs
import euaPasswordResetConfig from './configs/cms-employee-or-contractor-support/eua-password-reset';
import pivCardConfig from './configs/cms-employee-or-contractor-support/piv-card';
import allOtherIssuesConfig from './configs/cms-employee-or-contractor-support/all-other-issues';

// Application Support Configs
import eqrsAccessConfig from './configs/application-support/eqrs-access';
import hqrAccessConfig from './configs/application-support/hqr-access';
import iqiesAccessConfig from './configs/application-support/iqies-access';
import qppAccessConfig from './configs/application-support/qpp-access';
import qsepAccessConfig from './configs/application-support/qsep-access';
import allOtherHarpApplicationsConfig from './configs/application-support/all-other-harp-applications';

export const TOPICS = [
  {
    label: 'HARP',
    value: 'harp',
  },
  {
    label: 'CMS Employee or Contractor Support',
    value: 'cmsEmployeeOrContractorSupport',
  },
  {
    label: 'Application Support',
    value: 'applicationSupport',
  },
];

export const SUBTOPICS = {
  harp: [
    {
      label: 'Password & Account Recovery',
      value: 'passwordAndAccountRecovery',
    },
    {
      label: 'Manual Identity Proofing Issues',
      value: 'manualIdentityProofingIssues',
    },
    {
      label: 'User Research Feedback',
      value: 'userResearchFeedback',
    },
  ],
  cmsEmployeeOrContractorSupport: [
    { label: 'EUA Password Reset', value: 'euaPasswordReset' },
    { label: 'PIV Card', value: 'pivCard' },
    { label: 'All Other Issues', value: 'allOtherIssues' },
  ],
  applicationSupport: [
    {
      label: 'EQRS Access',
      value: 'eqrsAccess',
    },
    {
      label: 'HQR Access',
      value: 'hqrAccess',
    },
    {
      label: 'iQIES Access',
      value: 'iqiesAccess',
    },
    {
      label: 'QPP Access',
      value: 'qppAccess',
    },
    {
      label: 'QSEP Access',
      value: 'qsepAccess',
    },
    {
      label: 'All Other Applications',
      value: 'allOtherApplications',
    },
  ],
};

export const CONFIG_MAP = {
  harp: {
    passwordAndAccountRecovery: passwordAndAccountRecoveryConfig,
    manualIdentityProofingIssues: manualIdentityProofingConfig,
    userResearchFeedback: userResearchFeedbackConfig,
  },
  cmsEmployeeOrContractorSupport: {
    euaPasswordReset: euaPasswordResetConfig,
    pivCard: pivCardConfig,
    allOtherIssues: allOtherIssuesConfig,
  },
  applicationSupport: {
    eqrsAccess: eqrsAccessConfig,
    hqrAccess: hqrAccessConfig,
    iqiesAccess: iqiesAccessConfig,
    qppAccess: qppAccessConfig,
    qsepAccess: qsepAccessConfig,
    allOtherApplications: allOtherHarpApplicationsConfig,
  },
};
